import { render, staticRenderFns } from "./DashboardCardLandlords.vue?vue&type=template&id=1be80790&"
import script from "./DashboardCardLandlords.vue?vue&type=script&lang=js&"
export * from "./DashboardCardLandlords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports